import { createFileRoute } from '@tanstack/react-router';

import { ColorSelector } from '@/features/colors/ColorSelector';

export const Route = createFileRoute('/_authenticated/colors/')({
  component: ColorSelector,
});
